import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import AudioUploadField from '../../../components/media/AudioUploadField';

const CmsSettingsSection = ({ content, onChange }) => {
  const settings = content?.settings || {};
  const music = settings?.backgroundMusic || {};

  const updateSettings = (field, value) => {
    onChange({
      ...content,
      settings: { ...settings, [field]: value },
    });
  };

  const updateMusic = (field, value) => {
    onChange({
      ...content,
      settings: {
        ...settings,
        backgroundMusic: { ...music, [field]: value },
      },
    });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-romantic-sm border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="Settings" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">General Settings</h3>
      </div>

      <div className="space-y-6">
        {/* Background Music */}
        <div>
          <h4 className="text-sm font-semibold text-foreground uppercase tracking-wide mb-3">Background Music</h4>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={music?.enabled || false}
                  onChange={(e) => updateMusic('enabled', e.target.checked)}
                  className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
                />
                <span className="text-sm text-foreground">Enable background music</span>
              </label>
            </div>

            {music?.enabled && (
              <>
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">Music Source</label>
                  <div className="flex flex-col gap-3">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="musicType"
                        value="upload"
                        checked={music?.type !== 'url'}
                        onChange={() => updateMusic('type', 'upload')}
                        className="w-4 h-4 text-primary focus:ring-primary border-border"
                      />
                      <span className="text-sm text-foreground">Upload Audio File</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="musicType"
                        value="url"
                        checked={music?.type === 'url'}
                        onChange={() => updateMusic('type', 'url')}
                        className="w-4 h-4 text-primary focus:ring-primary border-border"
                      />
                      <span className="text-sm text-foreground">External URL</span>
                    </label>
                  </div>
                </div>

                {music?.type === 'url' ? (
                  <Input
                    label="Audio File URL"
                    type="url"
                    placeholder="https://example.com/song.mp3"
                    value={music?.url || ''}
                    onChange={(e) => updateMusic('url', e.target.value)}
                  />
                ) : (
                  <AudioUploadField
                    label="Audio File"
                    value={music?.url || ''}
                    onChange={(e) => updateMusic('url', e.target.value)}
                  />
                )}

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    Default Volume: {music?.volume || 70}%
                  </label>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={music?.volume || 70}
                    onChange={(e) => updateMusic('volume', Number(e.target.value))}
                    className="w-full h-2 bg-muted rounded-full appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-primary"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CmsSettingsSection;
